import React, { useState } from 'react';
import { Block, Heading3 } from '@awarego-ui/components';
import { observer } from 'mobx-react';
import ThemedSpinner from '../../../components/themed/ThemedSpinner';
import {
    ThemedNav,
    ThemedNavItem,
    ThemedNavLink,
} from '../../../components/themed/ThemedComponents';
import { TabContent, TabPane } from 'reactstrap';
import ListAssessmentsTable from './ListAssessmentsTable';
import ListTrainingsTable from './ListTrainingsTable';

function ListCampaignsTable({
    trainings = [],
    loadingTrainings,
    assessments = [],
    loadingAssessments,
}) {
    const [activeTab, setActiveTab] = useState('1');

    const tabsChange = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <Block mt={8}>
            <Heading3 mb={16}>Used in</Heading3>
            <ThemedNav clean>
                <ThemedNavItem active={activeTab === '1'}>
                    <ThemedNavLink
                        onClick={() => {
                            tabsChange('1');
                        }}
                    >
                        Training programs ({trainings.length})
                    </ThemedNavLink>
                </ThemedNavItem>
                <ThemedNavItem active={activeTab === '2'}>
                    <ThemedNavLink
                        onClick={() => {
                            tabsChange('2');
                        }}
                    >
                        Assessments ({assessments.length})
                    </ThemedNavLink>
                </ThemedNavItem>
            </ThemedNav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    {!loadingTrainings ? (
                        <ListTrainingsTable trainings={trainings} />
                    ) : (
                        <ThemedSpinner />
                    )}
                </TabPane>
                <TabPane tabId="2">
                    {!loadingAssessments ? (
                        <ListAssessmentsTable assessments={assessments} />
                    ) : (
                        <ThemedSpinner />
                    )}
                </TabPane>
            </TabContent>
        </Block>
    );
}

export default observer(ListCampaignsTable);
